export default "__VITE_ASSET__DDNFY_Mk__"